export default {
  tablet: '@media screen and (min-width: 600px)',
  desktop: '@media screen and (min-width: 1024px)',
  biggerScreens: '@media screen and (min-width: 1920px)',
};
